import React, { useEffect, useState } from 'react'
import './style.css'
import { StepTwo } from './StepTwo'
import PropTypes from 'prop-types'
import {getTherapistNameAndLicensesFromString} from "../../utils/helper";

export const StepTwoContainer = ({ onClickConfirm, setChoiceDate, choiceDate, getDateIsError, getDate }) => {
  const [viewArray, setViewArray] = useState([])
  const [choiceError, setChoiceError] = useState(false)

  useEffect(() => {
    if (getDate && !getDateIsError) {
      setViewArray(getDate.data.data.item)
    }
  }, [getDate])

  const onClickChoice = (e) => {
    const selected = e.id === choiceDate.id ? {} : e
    setChoiceDate(selected)
    setChoiceError(false)
    const therapistData = getTherapistNameAndLicensesFromString(e.name);
    const selectedData = {
          id: selected.id,
          name: therapistData.name,
          licenses: therapistData.licenses,
          description: selected.description,
          duration: selected.duration,
          dateTime: selected.dateTime,
        }
    if (Object.keys(selected).length) {
      const expiryDays = 1
      const expiryDate = new Date()
      expiryDate.setTime(expiryDate.getTime() + expiryDays * 24 * 60 * 60 * 1000)
      document.cookie = `group_match_submit=${encodeURIComponent(JSON.stringify(selectedData))}; expires=${expiryDate.toUTCString()}; path=/;`
      
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'group_match_submit',
        groupData: selectedData,
      })
    }
  }


  const onClickNext = () => {
    if (Object.keys(choiceDate).length) {
      onClickConfirm(3)
    } else {
      setChoiceError(true)
    }
  }

  return (
    <StepTwo
      choiceDate={choiceDate}
      onClickNext={onClickNext}
      onClickChoice={onClickChoice}
      viewArray={viewArray}
      choiceError={choiceError}
    />
  )
}

StepTwoContainer.propTypes = {
  onClickConfirm: PropTypes.func,
  setChoiceDate: PropTypes.func,
  choiceDate: PropTypes.object,
  getDate: PropTypes.object,
  getDateIsError: PropTypes.bool
}
